/**
 * A tela "Originados" (história 3.11) — o que a SDR originou, e no que deu.
 *
 *     /originados    a lista dos Negócios cujo campo SDR é quem está olhando (FR-35)
 *
 * Ela é filha de `rotaDaAplicacao`, e por isso herda a guarda de sessão do layout — registrada
 * uma vez lá, ela vale para toda rota interna.
 *
 * **O caminho é novo, e não um placeholder que virou tela.** Até a 3.11 o item "Originados" da
 * sidebar da SDR apontava para `/relatorios`, que era então o placeholder do Épico 7: o menu
 * prometia uma tela que não existia. Dar corpo a `/relatorios` obrigaria a mesma rota a ser lista
 * real para um perfil e promessa vazia para os outros três; um caminho próprio manteve a promessa
 * separada e deu à SDR um destino de verdade. Desde a 7.2 `/relatorios` também tem tela — a
 * conversão por Responsável e a de funil por Etapa —, e a separação continua valendo: são dois
 * relatórios diferentes, e não o mesmo com dois rótulos. O caminho continua vindo de `CAMINHOS` — item de menu e rota nascem da
 * **mesma** lista —, e `telas.ts` o tira do laço de placeholders por `COM_TELA_PROPRIA`.
 *
 * **A rota existe para todos, e o menu é que é por perfil.** Um Vendedor que digite `/originados`
 * encontra a tela e vê a lista dele — vazia, se ele nunca foi SDR de nada. É a regra que a sidebar
 * já escreve: esconder item não é autorizar, e quem recusa é o serviço.
 *
 * **Ela não passa nada por prop, ao contrário de `hoje.tsx` e `funil.tsx`.** Lá a rota resolve o
 * que é **contexto da tela** — o catálogo de Funis, os dois cortes da régua — e passa adiante. Aqui
 * não há contexto: a lista não desenha Etapa (o serviço não manda `etapa_id`) e não tem cor (não há
 * régua nesta tela). O que ela consulta — a lista, os nomes de Empresa e os rótulos de Motivo — é o
 * **conteúdo**, e conteúdo o componente consulta sozinho.
 *
 * **Sem cabeçalho próprio — e é por isso que ela precisa emprestar o título ao shell.** O `<h1>`
 * da página é o do `Cabecalho`, e um segundo título aqui daria dois na mesma tela. Só que o título
 * do shell sai do **item de navegação** da rota aberta, e este item existe apenas para a SDR: para
 * Vendedor, Gestor e Admin — que alcançam `/originados` digitando o caminho, como o parágrafo
 * acima diz — `itemDoCaminho` devolve `undefined` e o cabeçalho cairia no fallback
 * `'CRM Orvalho do Sol'`. `useDefinirTitulo` é o par que a 3.10 acrescentou para exatamente isto,
 * e o texto é o **mesmo** do item (`TITULO_DOS_ORIGINADOS`), escrito uma vez em `navegacao.ts`:
 * publicá-lo aqui não muda nada para a SDR e conserta os outros três.
 */

import { createRoute } from '@tanstack/react-router'

import { ListaDeOriginados } from '@/modulos/negocios/ListaDeOriginados'
import { useDefinirTitulo } from '@/shell/Shell'
import { CAMINHOS, TITULO_DOS_ORIGINADOS } from '@/shell/navegacao'
import { rotaDaAplicacao } from './aplicacao'

function TelaDeOriginados() {
  useDefinirTitulo(TITULO_DOS_ORIGINADOS)

  return <ListaDeOriginados />
}

export const rotaDeOriginados = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: CAMINHOS.originados,
  component: TelaDeOriginados,
})
